export default __webpack_public_path__ + "static/media/form.fd27069f.webp";